import { useEffect, useState, useCallback } from "react";
import { toast } from "sonner";
import { Check, Ban } from "lucide-react";
import { rpc } from "@/lib/supabase";
import { PageHeader, Loader } from "@/components/kit";
import { AdminTable } from "@/components/AdminTable";

const APPROVAL = {
  APPROVED: { label: "Aprobado", cls: "text-emerald-400 bg-emerald-500/10 border-emerald-500/40" },
  PENDING: { label: "Pendiente", cls: "text-amber-400 bg-amber-500/10 border-amber-500/40" },
  SUSPENDED: { label: "Suspendido", cls: "text-red-400 bg-red-500/10 border-red-500/40" },
};

export default function AdminDrivers() {
  const [rows, setRows] = useState(null);
  const [busy, setBusy] = useState(false);
  const load = useCallback(() => {
    rpc("admin_get_drivers").then((d) => setRows(d || [])).catch(() => setRows([]));
  }, []);
  useEffect(() => { load(); }, [load]);

  const act = async (fn, id, msg) => {
    setBusy(true);
    try {
      await rpc(fn, { p_driver_id: id });
      toast.success(msg);
      load();
    } catch (e) {
      toast.error(e?.message || "Error");
    } finally {
      setBusy(false);
    }
  };

  if (rows === null) return <Loader />;
  const columns = [
    { key: "full_name", label: "Conductor", render: (r) => <span className="font-semibold text-white">{r.full_name || "—"}</span> },
    { key: "phone", label: "Teléfono" },
    { key: "vehicle", label: "Vehículo", render: (r) => (r.vehicle ? `${r.vehicle.plate || ""} · ${r.vehicle.brand || ""} ${r.vehicle.model || ""}` : "Sin vehículo") },
    { key: "delivered_count", label: "Entregas" },
    { key: "driver_approval", label: "Estado", render: (r) => {
        const a = APPROVAL[r.driver_approval] || APPROVAL.PENDING;
        return <span className={`rounded-full border px-2.5 py-1 text-xs font-bold ${a.cls}`}>{a.label}</span>;
      } },
    { key: "actions", label: "Acciones", render: (r) => (
        <div className="flex gap-2">
          {r.driver_approval !== "APPROVED" && (
            <button onClick={() => act("admin_approve_driver", r.id, "Conductor aprobado")} disabled={busy} data-testid={`approve-driver-${r.id}`} className="flex items-center gap-1 rounded-lg bg-emerald-500/15 px-2.5 py-1.5 text-xs font-bold text-emerald-400 hover:bg-emerald-500/25">
              <Check size={13} /> Aprobar
            </button>
          )}
          {r.driver_approval !== "SUSPENDED" && (
            <button onClick={() => act("admin_suspend_driver", r.id, "Conductor suspendido")} disabled={busy} data-testid={`suspend-driver-${r.id}`} className="flex items-center gap-1 rounded-lg bg-red-500/10 px-2.5 py-1.5 text-xs font-bold text-red-400 hover:bg-red-500/20">
              <Ban size={13} /> Suspender
            </button>
          )}
        </div>
      ) },
  ];
  return (
    <div>
      <PageHeader title="Conductores" subtitle="Aprueba o suspende cuentas de conductor." testId="admin-drivers" />
      <AdminTable columns={columns} rows={rows} testId="admin-drivers-table" empty="No hay conductores" />
    </div>
  );
}
